module.exports = __webpack_public_path__ + "institucion.png?26c69573eb226fe3f67b8206890113ef";


//////////////////
// WEBPACK FOOTER
// ./src/assets/institucion.png
// module id = 641
// module chunks = 0 2 7 8 9 10 17 21